'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _reactRouterRedux = require('react-router-redux');

var _richMediaContentStateReducer = require('./richMediaContentStateReducer');

var _richMediaContentStateReducer2 = _interopRequireDefault(_richMediaContentStateReducer);

var _richMediaConstants = require('./richMediaConstants');

var _draggingConstants = require('../../reducers/draggingConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants
// Lib
var individualRichMediaReducer = (0, _reduxImmutable.combineReducers)({
    contentState: _richMediaContentStateReducer2.default
});

// Reducers


var updateId = function updateId(state, action, id) {
    return state.update(id, function (currIdState) {
        return individualRichMediaReducer(currIdState, action);
    });
};
var delegateToId = function delegateToId(state, action) {
    return updateId(state, action, action.id);
};

var delegateToAllIds = function delegateToAllIds(state, action) {
    return state.withMutations(function (mutableState) {
        return action.ids && action.ids.forEach(function (id) {
            return updateId(mutableState, action, id);
        });
    });
};

var delegateToAllEntries = function delegateToAllEntries(state, action) {
    return state.withMutations(function (mutableState) {
        return mutableState.forEach(function (val, id) {
            return updateId(mutableState, action, id);
        });
    });
};

// The rich media state is a map of ID to { contentState }
var initialState = Immutable.Map();

exports.default = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case _richMediaConstants.RICH_MEDIA_EMBEDDING:
        case _richMediaConstants.RICH_MEDIA_ERROR:
        case _richMediaConstants.RICH_MEDIA_READY:
        case _richMediaConstants.RICH_MEDIA_RETURN_TO_PREVIEW:
            return delegateToId(state, action);
        case _draggingConstants.DRAG_START:
            return delegateToAllIds(state, action);
        case _reactRouterRedux.LOCATION_CHANGE:
            return delegateToAllEntries(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/richMediaReducer.js
// module id = 2022
// module chunks = 0